import React from 'react';

import ShortVideoContentItem, {
	ShortVideoContentItemProps,
} from '@components/report/content-items/short-video-content-item/ShortVideoContentItem';
import NoDataSection from '@components/report/no-data-section/NoDataSection';
import SnapCarousel from '@shared/snap-carousel/SnapCarousel';
import { lackOfPermissionClass } from '@components/report/style.css';

export interface VideoContentIgProps {
	items?: ShortVideoContentItemProps[];

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const VideoContentIg = ({
	isLoading,
	isError,
	lackOfPermission,
	...props
}: VideoContentIgProps) => {
	const status = { isLoading, isError, lackOfPermission };
	const available = !isLoading && !isError && !lackOfPermission;
	const items = !available
		? new Array(20).fill({} as ShortVideoContentItemProps)
		: props.items ?? [];

	if (!available || (available && items.length > 0))
		return (
			<SnapCarousel
				className={lackOfPermission ? lackOfPermissionClass : ''}
				items={items?.map((item, idx) => (
					<ShortVideoContentItem key={idx} idx={idx} {...item} {...status} />
				))}
			/>
		);
	else return <NoDataSection />;
};

export default VideoContentIg;
